export const greatestCommonDenominator = (a, b) => (!b ? a : greatestCommonDenominator(b, a % b));
export const leastCommonMultiple = (a, b) => (a * b) / greatestCommonDenominator(a, b);

/**
 * Calculates the true modulo of n % m, handling negative numbers correctly.
 * @param {number} n The dividend
 * @param {number} m The divisor
 * @returns {number} The positive remainder
 */
export const mod = (n, m) => ((n % m) + m) % m;
